import fp from 'lodash/fp';

const flattenRows = (level, parentId) => fp.flow(
    fp.entries,
    fp.reduce(
        (flatRows, [childIndex, row]) => ([
            ...flatRows,
            {
                ...row, level, parentId, childIndex: +childIndex, children: row.children && row.children.map((x) => x.id)
            },
            ...(flattenRows(level + 1, row.id)(row.children || []))
        ]),
        []
    )
);

export default fp.flow(
    flattenRows(0, undefined),
    fp.map(fp.set('expanded', true))
);
